module.exports = __webpack_public_path__ + "img/marker-icon-drone.e7705793.png";